import { render, staticRenderFns } from "./ShippingMethodList.vue?vue&type=template&id=44faa278&scoped=true&"
import script from "./ShippingMethodList.vue?vue&type=script&lang=js&"
export * from "./ShippingMethodList.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMethodList.vue?vue&type=style&index=0&id=44faa278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44faa278",
  null
  
)

export default component.exports